import { re } from "mathjs";
import {
  CHANGE_CHARACTER,
  INITIALISING_PANEL_STARTED,
  START_NEW_GAME,
  SHOW_CHARACTER_DEATH_PAGE,
  GET_ORDERS_SUCCESS,
  ADD_ORDER,
  UPDATE_ORDER,
  REMOVE_ORDER,
  GET_COMPLETED_ORDERS_SUCCESS,
  ADD_COMPLETED_ORDER,
  UPDATE_COMPLETED_ORDER,
  REMOVE_COMPLETED_ORDER,
} from "../actionTypes";

const initialState = {
  orders: []
};

const SCHEDULE_REPETITIONS = {
    SINGLE_TIME: 's',
    ONCE_DAILY: 'd',
    INDEFINITE_DAILY: 'i',
    REACTION: 'r'
}

export default function(state = initialState, action) {
  switch (action.type) {
    case START_NEW_GAME:
    case INITIALISING_PANEL_STARTED:
    case CHANGE_CHARACTER:
    case SHOW_CHARACTER_DEATH_PAGE: {
      return {
        ...initialState,
      }
    }
    case GET_ORDERS_SUCCESS: {
      const orders = action.payload;

      return {
        ...state,
        orders: [...new Set(orders)],
      }
    }

    case GET_COMPLETED_ORDERS_SUCCESS: {
      const completedOrders = action.payload;

      const updatedOrders = [...state.orders].map(order => {
        const isCompleted = Boolean(completedOrders.find(completedOrder => (completedOrder._id === order._id)))

        return {
          ...order,
          isCompleted
        }
      })

      const fullyCompletedOrders = completedOrders
        .filter(completedOrder => (!updatedOrders.find(order => (order._id === completedOrder._id))))
        .map(order => ({ ...order, isCompleted: true, isFullyCompleted: true }))

      return {
        ...state,
        orders: [...updatedOrders, ...fullyCompletedOrders]
      }
    }

    case ADD_ORDER: {
      let orders = [...state.orders.filter(order => order._id !== action.payload._id), action.payload];

      return {
        ...state,
        orders: [ ...orders ],
      }
    }

    case UPDATE_ORDER: {
      if (!action.payload._id || !action.payload.type) {
        return {
          ...state,
        }
      }

      let orders = [...state.orders];

      const duplicatedOrders = state.orders.filter(order => order._id === action.payload._id)

      orders = orders.map(order => {
        if (!order) {
          return order
        }

        if (order.characterId !== action.payload.characterId) {
          return order;
        }

        if (order._id === action.payload._id) {
          return {
            ...order,
            ...action.payload,
            waitCost: action.payload.waitCost || order.waitCost,
            waitCount: action.payload.waitCount || order.waitCount,
            isActive: true
          }
        }

        return {
          ...order,
          isActive: false
        }
      })

      return {
        ...state,
        orders: [ ...new Set(orders) ],
      }
    }

    case REMOVE_ORDER: {
      return {
        ...state,
        orders: [ ...new Set(state.orders.filter(order => (order._id !== action.payload._id))) ],
      }
    }

    case ADD_COMPLETED_ORDER: {
      let orders = [...state.orders, { ...action.payload, isCompleted: true }];

      return {
        ...state,
        orders: [ ...orders ],
      }
    }

    case UPDATE_COMPLETED_ORDER: {
      let orders = [...state.orders.filter(order => order._id !== action.payload._id), { ...state.orders.find(order => order._id === action.payload._id), ...action.payload, isCompleted: true }];

      return {
        ...state,
        orders: [ ...orders ],
      }
    }

    case REMOVE_COMPLETED_ORDER: {
      const removedOrder = state.orders.find(order => (order._id === action.payload._id));

      if (!removedOrder) {
        return { ...state };
      }

      if (removedOrder.weight === SCHEDULE_REPETITIONS.ONCE_DAILY || removedOrder.weight === SCHEDULE_REPETITIONS.REACTION) {
        return {
          ...state,
          orders: [ ...state.orders.filter(order => (order._id !== action.payload._id)), {...removedOrder, isCompleted: false} ],
        }
      }

      return {
        ...state,
        orders: [ ...state.orders.filter(order => (order._id !== action.payload._id)) ],
      }
    }

    default:
      return state;
  }
}
